import React from 'react';
import classNames from 'classnames';

import { Container } from 'app/components/common/container/container';

import styles from './small-container.module.scss';

interface Props {
    additionalStyles?: string;
}

export const SmallContainer: React.FC<Props> = (props: Props) => {
    const { additionalStyles } = props;

    const className = classNames(styles.smallContainer, additionalStyles);

    return <Container {...props} additionalStyles={className} />;
};
